import React from 'react';
import RadioButton from 'components/RadioButton';
import Price from 'components/Price';
import Hours from '../Hours';
import Day from 'dayjs';
import PropTypes from 'prop-types';
import style from './style.scss'; //NOSONAR


const DeliveryWindowsRadio = ({hours, daySelected, express, selectExpress, validateExpress, selectedHours}) => {

    const today = Day().format('YYYY-MM-DD');
    let leftColumn = (hours && hours.length > 1) ? hours.slice(0, Math.round(hours.length / 2)) : [];
    const rightColumn = (hours && hours.length > 1) ? hours.slice(Math.round(hours.length / 2), hours.length) : [];

    if (hours && (hours.length === 1)) {
        leftColumn = hours;
    }
    return (
        <div className="date-delivery-delivery-time-wrap">
            <div className="date-delivery-hours-scroll">
                <div className="date-delivery-wrap-hours">
                    {(express && express.validate) && (daySelected === today) && <div className="date-delivery-express">
                        <RadioButton item={selectExpress} name={'date-delivery'} callbackSelect={validateExpress} className="date-delivery-express-radio"/>
                        <div className="date-delivery-hours-and-price">
                            <span className={"date-delivery-hour"}> {express.time} min. </span>
                            <span className="date-delivery-price"><Price price={(express.price / 100)} /></span>
                        </div>
                    </div>}
                    {leftColumn.map((hour, i) => {
                        return (
                            <Hours expressFlag={i === 0 && today === daySelected ? true : false} hour={hour} key={i} callback={selectedHours} />
                        )
                    })}
                </div>
                <div className="date-delivery-wrap-hours">
                    {rightColumn.map((hour, i) => {
                        return (
                            <Hours hour={hour} key={i} callback={selectedHours} />
                        )
                    })}

                </div>
            </div>
        </div>
    )
}

DeliveryWindowsRadio.propTypes = {
    hours: PropTypes.array,
    daySelected: PropTypes.string,
    express: PropTypes.object,
    selectExpress: PropTypes.bool,
    validateExpress: PropTypes.func,
    selectedHours: PropTypes.func
}

export default DeliveryWindowsRadio;
